module.exports = "/dist/assets/images/Munch-logo.svg";